"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDpopKeyPair = exports.createDpopHeader = void 0;
const jose_legacy_modules_1 = require("@inrupt/jose-legacy-modules");
const uuid_1 = require("uuid");
const constant_1 = require("../constant");
function removeHashUsernameAndPassword(audience) {
    const cleanedAudience = new URL(audience);
    cleanedAudience.hash = "";
    cleanedAudience.username = "";
    cleanedAudience.password = "";
    return cleanedAudience.toString();
}
async function createDpopHeader(audience, method, dpopKey) {
    return new jose_legacy_modules_1.SignJWT({
        htu: removeHashUsernameAndPassword(audience),
        htm: method.toUpperCase(),
        jti: uuid_1.v4(),
    })
        .setProtectedHeader({
        alg: constant_1.PREFERRED_SIGNING_ALG[0],
        jwk: dpopKey.publicKey,
        typ: "dpop+jwt",
    })
        .setIssuedAt()
        .sign(dpopKey.privateKey, {});
}
exports.createDpopHeader = createDpopHeader;
async function generateDpopKeyPair() {
    const { privateKey, publicKey } = await jose_legacy_modules_1.generateKeyPair(constant_1.PREFERRED_SIGNING_ALG[0]);
    const dpopKeyPair = {
        privateKey,
        publicKey: await jose_legacy_modules_1.fromKeyLike(publicKey),
    };
    [dpopKeyPair.publicKey.alg] = constant_1.PREFERRED_SIGNING_ALG;
    return dpopKeyPair;
}
exports.generateDpopKeyPair = generateDpopKeyPair;
//# sourceMappingURL=dpopUtils.js.map